
import { mapState, mapGetters, mapActions } from 'vuex';
import ExternalEmbeddedSocialMediaInfoSection from './ExternalEmbeddedSocialMediaInfoSection';
import PaginatedReviewResourceView from '@/mixins/PaginatedReviewResourceView';
import UserRole from '@/enums/UserRole';
import ThumbnailShape from '@/enums/ThumbnailShape';
import SocialMediaType from '@/enums/SocialMediaType';

export default {
  i18nComponentKey: 'WidgetReviewsExternal.components.External',
  name: 'External',
  components: { ExternalEmbeddedSocialMediaInfoSection },
  mixins: [PaginatedReviewResourceView],
  computed: {
    ...mapState('reviewSettings', ['reviewSettings']),
    ...mapState('widget', ['isMobile']),
    ...mapState('facebook', ['enableEmbeddedFacebook']),
    ...mapGetters('widget', [
      'appHeaderShowable',
      'device',
      'headerSectionShowable',
      'showFilterSection'
    ]),
    defaultResourceParams() {
      return { fields: 'reviews.social_media_title,reviews.comments' };
    },
    processedReviews() {
      let reviews = this.reviews;
      if (this.widget.display_admin_comments_first) {
        reviews = reviews.map(review => ({
          ...review,
          comments: review.comments.sort(
            (a, b) =>
              UserRole.BRAND_MANAGER_ROLES.includes(b.user_role) -
              UserRole.BRAND_MANAGER_ROLES.includes(a.user_role)
          )
        }));
      }

      return reviews.map(review => ({
        ...review,
        comments: review.comments.slice(0, this.widget.comments_count_on_list)
      }));
    },
    columnGap() {
      return this.device === 'pc' ? 20 : 16;
    },
    minCardWidth() {
      return this.device === 'pc' ? 100 : 0;
    },
    productThumbnailType() {
      return this.widget.product_thumbnail_shape === ThumbnailShape.SQUARE
        ? 'rounded'
        : 'circle';
    },
    contentsStyle() {
      return {
        '--min-height': this.showFilterSection ? '204px' : 'auto'
      };
    }
  },
  async mounted() {
    await this.fetchFacebooks();
    this.initFacebook();
  },
  methods: {
    ...mapActions('widget', ['openReviewPopup']),
    ...mapActions('facebook', ['fetchFacebooks', 'initFacebook']),
    isEmbeddedFacebook(socialMediaType) {
      return (
        this.enableEmbeddedFacebook &&
        socialMediaType === SocialMediaType.FACEBOOK
      );
    },
    submit(params) {
      this.searchResource(params);
    }
  }
};
